export default (
  state = {
    allDocs: [],
    kanbanDocs: {},
    kanbanStatusMap: {},
    kanbanSearchTerm: "",
  },
  action,
) => {
  switch (action.type) {
    case "ALL_DOCS":
      return {
        ...state,
        allDocs: action.payload,
      };
    case "KANBAN_DOCS":
      return {
        ...state,
        kanbanDocs: action.payload,
      };
    case "KANBAN_STATUS_MAP":
      return {
        ...state,
        kanbanStatusMap: action.payload,
      };
    case "KANBAN_SEARCH_TERM":
      return {
        ...state,
        kanbanSearchTerm: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/KanbanReducer.js